export const PopupArticleController = () => {
  if(!$('body').hasClass('home') && !$('#case-popup').length) {
    return;
  }

  const $articleTrigger = $('.highlighted-case').find('.read-more');
  const $articleClose = $('#articlePopupClose');
  const activeClass = 'show-case-popup';

  enquire.register('screen and (min-width:900px)', {
    match : () => {
      $articleTrigger.on('click', (e) => {
        e.preventDefault();
        $('body').addClass(activeClass);
      })

      $articleClose.on('click', (e) => {
        e.preventDefault();
        $('body').removeClass(activeClass);
      })
    },

    unmatch : () => {
      $articleTrigger.off('click');
      $articleClose.off('click');
      $('body').removeClass(activeClass);
    },
  });
}



// WEBPACK FOOTER //
// ./src/js/controllers/PopupArticleController.js